module.exports = __webpack_public_path__ + "static/media/gandhi_jayanthi.1ae75ed4.jpeg";